import Glide, { Controls, Breakpoints, Swipe, Images, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

const settings = {
	gallery: '.glide',
	single: 'gallery--single'
};

export function init () {
	const $gallery = $(settings.gallery);
	if ($gallery.length) {
		$gallery.each(function() {
			const $this = $(this);

			const config = $this.data('glide-config');
			const isSingle = $this.hasClass(settings.single);

			const updatedConfig = Object.assign({}, {
				type: 'carousel',
				gap: 30
			}, config);

			const glide = new Glide($this.get(0), updatedConfig).mount({ Controls, Breakpoints, Swipe, Images, Autoplay });

			if (isSingle) {
				glide.disable();
			}
		});
	}
}

init();
